import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isInApp} from 'ubs-framework/src/common/function'
import {sendMessageRNW} from '../../../common/functions/common';
import {IS_DEV} from 'ubs-framework/v2/common/constant';
import usePlan from '../hooks/usePlan';
import {PLAN} from 'ubs-framework/v2/common/constant';
const withLocation = (WrappedComponent, classes) => {
    return (props) => {
        const __plan = usePlan();
        const DISPATCH = useDispatch();
        const _L = useSelector(e => e.memorize?.location);
        const _IS_LOCATION = useSelector(e => (__plan(PLAN?.geoTagging) && e.hrms?.loginMethod?.GEO_TAGGING) || (__plan(PLAN?.routeMap) && e.hrms?.loginMethod?.LIVE_TRACKING) || ((__plan(PLAN?.geoFencing) && e.hrms.attendanceGEOFencing) || []).length > 0);
        const _IS_LIVE_TRACKING = useSelector(e => __plan(PLAN?.routeMap) && e.hrms?.loginMethod?.LIVE_TRACKING);

        const location = {
            permission: (cb) => {
                if (isInApp() && !!window?.ReactNativeWebView) {
                    DISPATCH({type: 'UPDATE_LOCATION', payload: {lat: 0, lng: 0, address: "", permission: ""}})
                    sendMessageRNW(6, {location: _IS_LOCATION, backgroundLocation: !!_IS_LIVE_TRACKING})
                } else {
                    if (navigator?.permissions?.query) {
                        navigator?.permissions?.query({
                            name: 'geolocation'
                        }).then((result) => {
                            if(cb) cb(result.state)
                            DISPATCH({type: 'UPDATE_LOCATION', payload: {permission: result.state}})
                            if (result.state === 'granted' || IS_DEV) {
                                location.getLatLng()
                            }
                            result.onchange = function () {
                                console.log('function ===========', result.state);
                            }
                        });
                    } else {
                        location.getLatLng()
                    }
                }
            },
            getLatLng: () => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        DISPATCH({type: 'UPDATE_LOCATION', payload: {permission: 'granted'}})
                        const lat = position.coords.latitude
                        const lng = position.coords.longitude
                        DISPATCH({type: 'UPDATE_LOCATION', payload: {lat, lng, address: ""}})
    
                    }, (error) => {
                        console.log('error ===========', error);
                        if (_L.permission) DISPATCH({type: 'UPDATE_LOCATION', payload: {permission: false}})
                    });
                } else {
                    console.log("Geolocation is not supported by this browser.")
                }
            }
        }
        return (
            <WrappedComponent {...props} getLocationPermission={location.permission}/>
        );
    }
};

export default withLocation;
